<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_PROCESANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <form [formGroup]="formulario" *ngIf="!editando" (ngSubmit)="onSubmit()" novalidate id="fFormulario" name="nomFormuvalidarTasalario">
    <div class="grid form-group">
      <!-- Select de la integracion -->
      <div class="col-12 md:col-4 lg:col-4">
        <div class="div-form">
          <label>* {{ 'PERFILRIESGOSCORE.LBL_PROVEEDOR' | translate }}</label>
          <p-dropdown disableTab  id="idProveedorScore" name="idProveedorScore" [options]="listProveedor"
                      placeholder="{{ 'LBL_SELECCIONE' | translate}}" (onChange)="cambiarTipo()"
                       formControlName="idProveedorScore"
          ></p-dropdown>
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idProveedorScore.invalid">
            {{ 'PERFILRIESGOSCORE.LBL_PROVEEDOR' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>
      </div>
      <div class="col-12 md:col-4 lg:col-4">
        <div class="div-form">
          <label>* {{ 'PERFILRIESGOSCORE.LBL_TIPO' | translate }}</label>
          <p-dropdown disableTab  id="idModalidad" name="idTipoScore" [options]="listTipo"
                      placeholder="{{ 'LBL_SELECCIONE' | translate}}" (onChange)="cambiarTipo()"
                       formControlName="idTipoScore"
          ></p-dropdown>
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idTipoScore.invalid">
            {{ 'PERFILRIESGOSCORE.LBL_TIPO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>
      </div>
      <div class="col-12 md:col-4 lg:col-4" *ngIf="verValor">
        <div class="div-form">
          <label>* {{ 'PERFILRIESGOSCORE.LBL_VALOR' | translate }}</label>
          <input type="text" pInputText id="valor"
                 name="valor"
                 [negativo]="true" [sinMaximoPosible]="true"
                 autocomplete="off"
                 formControlName="valor" (keyup)="reloadErrorValor()"
                 numero-entero-reactive [maxLength]="9"
          >
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.valor.invalid">
            {{ 'PERFILRIESGOSCORE.LBL_VALOR' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && errorValor">
            {{ 'PERFILRIESGOSCORE.LBL_ERRORVALOR' | translate}}
          </div>
        </div>
      </div>
      <div class="col-12 md:col-4 lg:col-4" *ngIf="verRango">
        <div class="div-form">
          <label>* {{ 'PERFILRIESGOSCORE.LBL_DESDE' | translate }}</label>
          <input type="text" pInputText id="desde"
                 name="desde"
                 [negativo]="true" [sinMaximoPosible]="true"
                 autocomplete="off"
                 formControlName="desde"
                 (change)="validarDesde($event.target.value)"
                 numero-entero-reactive [maxLength]="9"
          >
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.desde.invalid">
            {{ 'PERFILRIESGOSCORE.LBL_DESDE' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && errorRango || errorRango">
            {{ 'PERFILRIESGOSCORE.LBL_ERRORRANGO' | translate}}
          </div>
          <div class="p-message p-messages-error p-corner-all" *ngIf="errorDesde">
            {{ 'PERFILRIESGOSCORE.LBL_ERRORDESDE' | translate}}
          </div>
        </div>
      </div>
      <div class="col-12 md:col-4 lg:col-4" *ngIf="verRango">
        <div class="div-form">
          <label>* {{ 'PERFILRIESGOSCORE.LBL_HASTA' | translate }}</label>
          <input type="text" pInputText id="hasta"
                 name="hasta" [negativo]="true" [sinMaximoPosible]="true"
                 autocomplete="off"
                 formControlName="hasta" (change)="validarHasta($event.target.value)"
                 numero-entero-reactive [maxLength]="9"
          >
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.hasta.invalid">
            {{ 'PERFILRIESGOSCORE.LBL_HASTA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && errorRango || errorRango">
            {{ 'PERFILRIESGOSCORE.LBL_ERRORRANGO' | translate}}
          </div>
          <div class="p-message p-messages-error p-corner-all" *ngIf="errorHasta">
            {{ 'PERFILRIESGOSCORE.LBL_ERRORHASTA' | translate}}
          </div>
        </div>
      </div>
    </div>
    <div class="grid form-footer-buttons">
      <div class="form-group col-12">
        <div *ngIf="!guardando">
          <a (click)="cancelar(formulario.dirty)" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
          <button icon="fa fa-plus" label="{{(f.idPerfilRiesgoScore.value ? 'BTN_ACTUALIZAR' : 'BTN_AGREGAR') | translate }}"
                  type="submit"
                  pButton></button>
        </div>
        <div *ngIf="guardando">
          <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
          <span>{{'LBL_GUARDANDO' | translate }}</span>
        </div>
      </div>
    </div>
  </form>

  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-table [columns]="columnas"  [loading]="cargarTable"
               [value]="listadoPorPerfilRiesgoScore"
               [paginator]="true" [rows]="5"  paginatorPosition="bottom"
      >
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
              {{col.header}}
              <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
          <tr>
            <td>{{row.proveedorScore}}</td>
            <td>{{row.tipoScore}}</td>
            <td>{{row.valor}}</td>
            <td>{{row.desde}}</td>
            <td>{{row.hasta}}</td>
            <td class="text-center" *ngIf="!editando">
              <div class="btn-group" role="group">
                <button type="button" class="p-button p-button-success btn" icon="fa fa-trash" data-toggle="tooltip"
                        title="{{'BTN_ELIMINAR' | translate}}" pButton
                        (click)="eliminar(row,rowIndex)"></button>
                <button type="button" class="p-button p-button-success btn" icon="fa fa-pencil" data-toggle="tooltip"
                        title="{{'BTN_EDITAR' | translate}}" pButton
                        (click)="editar(row,rowIndex)"></button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length">
              {{ 'MSG_NOHAYREGISTROS' | translate}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
<p-confirmDialog #cd key="score">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
